import { ResourceType } from '../../../../../../@data/store/schema/enums/ResourceType';
import { IGlobalSearchResult } from '../../../../../../@data/store/schema/interfaces/IGlobalSearchResult';
import { SearchResult } from './SearchResult';

export class User extends SearchResult {
  public fullName?: string;
  public publisherName?: string;
  private _item: IGlobalSearchResult;

  constructor(item?: IGlobalSearchResult) {
    super(item && item.resourceName, item && item.resourceId, 'Contact');
    if (item) {
      this.fullName = item.propertyBag && item.propertyBag.FullName;
      this.publisherName = item.propertyBag && item.propertyBag.PublisherName;
      this._item = item;
    }
  }

  public getPublisherId(): string {
    if (this._item && this._item.propertyBag && this._item.propertyBag.PublisherId) {
      return this._item.propertyBag.PublisherId;
    }

    return '';
  }

  public getAccountId(): string {
    if (this._item && this._item.propertyBag && this._item.propertyBag.AccountId) {
      return this._item.propertyBag.AccountId;
    }

    return '';
  }

  public getResourceType(): string {
    return ResourceType[ResourceType.User];
  }
}
